import { useForm } from "@inertiajs/react"
import { usePuzzle } from "@/hooks/usePuzzle"
import { Modals, useModals } from "@/hooks/useModals"
import Button from "@/components/Button"

const ActionBar = () => {
  const { delete: destroy, processing } = useForm()
  const { id, hasMoves, draft, discoverable } = usePuzzle()
  const { openModal } = useModals()

  const handleDelete = () => {
    const needsConfirmation = hasMoves

    const confirmation = needsConfirmation
      ? confirm("Are you sure you want to delete this puzzle?")
      : true

    if (!confirmation) return

    destroy(`/puzzles/${id}`, {
      async: true,
      preserveScroll: true,
      preserveState: true,
    })
  }

  return (
    <div className="flex items-center gap-x-1.5">
      <Button
        size="sm"
        style="secondary"
        onClick={handleDelete}
        loading={processing}
      >
        Delete puzzle
      </Button>
      {!draft && discoverable && (
        <Button
          size="sm"
          onClick={() => openModal(Modals.Share)}
          disabled={processing}
        >
          Share puzzle
        </Button>
      )}
    </div>
  )
}

export default ActionBar
